import { render, staticRenderFns } from "./OptionsGroup.vue?vue&type=template&id=41004572&"
import script from "./OptionsGroup.vue?vue&type=script&lang=js&"
export * from "./OptionsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports